/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".inner-div[_ngcontent-%COMP%]{margin:10px}.value-span[_ngcontent-%COMP%]{color:red;text-align:right;margin-left:10px;font-weight:700}.label-span[_ngcontent-%COMP%]{font-weight:700}\n/*# sourceMappingURL=fraud-card.component.css.map*/"];
export { styles as styles };
